<template>
  <div
    class="announcement"
    :style="elStyle"
  >
    <div class="message" @click="msgClick">
      <EllipsisDiv
        :key="messageKey"
        class="message-content"
        :text="announcement.message"
      />
    </div>
    <img
      class="close"
      alt=""
      :src="closeImgSrc"
      @click="close"
    >
  </div>
</template>

<script>
/**
 * A message in AnnouncementsBanner
 */
// Vuex
import { HIDE_ANNOUNCEMENT } from '@/store/mutation-types';
// Components
import EllipsisDiv from '@/components/ellipsize.vue';
// Utils
import { calert, isColorDark } from '@/utils/main';

const closeImg = require('@/assets/img/close-medium-gray.png');
const closeWhiteImg = require('@/assets/img/close-medium-white.png');

export default {
  name: 'Announcement',
  components: {
    EllipsisDiv,
  },
  props: {
    announcement: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      messageKey: 1,
    };
  },
  computed: {
    /** Style of this.$el */
    elStyle() {
      const { background, color } = this.announcement;
      return {
        background,
        color,
      };
    },
    /** Close icon according to text color */
    closeImgSrc() {
      const { color } = this.announcement;
      return color === '' || isColorDark(color) ? closeImg : closeWhiteImg;
    },
  },
  created() {
    $(window).on(`resizeEnd.${this.uuid}`, () => {
      this.messageKey++;
    });
  },
  methods: {
    /** Remove the message from the screen */
    close() {
      this.$store.commit(HIDE_ANNOUNCEMENT, this.announcement);
    },
    /** Message was cliced, open a modal to display it entirely */
    msgClick() {
      calert(this.announcement.message, [
        {
          title: this.$t('message.OK'),
        },
        {
          title: this.$t('message.REMOVE_ANNOUNCEMENT'),
          action: this.close,
        }
      ]);
    },
  },
};
</script>

<style lang="scss">
.announcement {
  line-height: 2em;

  .message {
    display: inline-block;
    vertical-align: middle;
    text-align: center;
    width: calc(100% - 2em);
    overflow: hidden;
    padding: 0px 15px;
    box-sizing: border-box;
    cursor: pointer;

    .message-content {
      max-height: 4em;
    }
  }
  .close {
    display: inline-block;
    vertical-align: middle;
    width: 1.3em;
    padding: 0.35em;
    cursor: pointer;
  }
}
</style>
